module.exports = __webpack_public_path__ + "img/handraw_fleche orange copie.facc13ad.svg";